import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden bg-cream" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="lg:w-1/2 text-center lg:text-left z-10" data-id="element-35">
            <span className="inline-block py-1 px-3 rounded-full bg-sage text-forest font-bold text-sm tracking-wider mb-6 uppercase" data-id="element-36">
              Método Freezer-Fit
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-forest font-bold leading-tight mb-6" data-id="element-37">
              Dejá de ser esclava de la cocina
            </h1>
            <p className="text-lg md:text-xl text-brown mb-8 font-sans max-w-2xl mx-auto lg:mx-0" data-id="element-38">
              Cómo tener todas tus viandas saludables listas en 2 horas y
              ahorrar un 40% en el súper.
            </p>
            <Button onClick={scrollToPricing} className="text-lg w-full sm:w-auto" data-id="element-39">
              QUIERO MI PLAN DE VIANDAS AHORA
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:w-1/2 relative" data-id="element-40">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/keVDuHd5HnQ97Gwx4jBmyz/concepto_1.png" alt="El antes y después de tu cocina: de cajas de delivery a viandas organizadas" className="w-full h-auto object-cover" data-id="element-42" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm py-2 px-4 rounded-lg shadow-md font-bold text-terracotta transform -rotate-6" data-id="element-43">
                El Antes vs El Después
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 top-1/2 -right-10 w-64 h-64 bg-sage rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-44"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-72 h-72 bg-terracotta/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-45"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}